import { useEffect, useState } from "react";
import SelectPropsType from "../../Types/SelectPropsType";

const StyledSelect = ({
  text,
  placeholder,
  optionList,
  onChange,
}: SelectPropsType) => {
  const [value, setValue] = useState("");

  useEffect(() => {
    onChange(value);
  }, [value]);


  return (
    <div className="styledInput">
      <div>{text}</div>
      <select
        className="styledSelect"
        onChange={(e) => setValue(e.target.value)}
        value={value}
      >
        <option value="" disabled selected>
          {placeholder}
        </option>
        {optionList.map((item, index) => {
          return (
            <option value={item} key={index}>
              {item}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default StyledSelect;
